import React from "react";
import { Link } from "react-router-dom";
import { BookOpenIcon, PlayCircleIcon } from "@heroicons/react/24/outline";
import { getExternalApiBaseUrl } from "../../services/externalApi";

/** Compact docs + agent setup links used in API pages. */
const ApiHelpLinks = ({ onAgentClick, showPlayground = false, className = "" }) => (
  <div className={`space-y-1 ${className}`}>
    {showPlayground && (
      <Link
        to="/api/"
        className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm text-theme-text hover:bg-theme-secondary hover:bg-opacity-40"
      >
        <PlayCircleIcon className="h-5 w-5 text-theme-primary shrink-0" />
        <span>
          <span className="block font-medium">Playground</span>
          <span className="block text-xs opacity-60">Try endpoints in the browser</span>
        </span>
      </Link>
    )}
    <a
      href={`${getExternalApiBaseUrl()}/docs/`}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm text-theme-text hover:bg-theme-secondary hover:bg-opacity-40"
    >
      <BookOpenIcon className="h-5 w-5 text-theme-primary shrink-0" />
      <span>
        <span className="block font-medium">Documentation</span>
        <span className="block text-xs opacity-60">All API endpoints and parameters</span>
      </span>
    </a>
    <button
      type="button"
      onClick={onAgentClick}
      className="w-full flex items-center gap-3 rounded-md px-3 py-2.5 text-sm text-theme-text hover:bg-theme-secondary hover:bg-opacity-40 text-left"
    >
      <RobotHeadIcon className="h-5 w-5 text-theme-primary shrink-0" />
      <span>
        <span className="block font-medium">Agent Instructions</span>
        <span className="block text-xs opacity-60">Connect MCP and copy setup</span>
      </span>
    </button>
  </div>
);

export function RobotHeadIcon({ className = "h-5 w-5" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="5" y="8" width="14" height="11" rx="3" />
      <path d="M12 8V5" />
      <circle cx="12" cy="4" r="1" fill="currentColor" stroke="none" />
      <circle cx="9" cy="13" r="1.25" fill="currentColor" stroke="none" />
      <circle cx="15" cy="13" r="1.25" fill="currentColor" stroke="none" />
      <path d="M9.5 16.5h5" />
      <path d="M5 12H3.5a1 1 0 0 0 0 2H5" />
      <path d="M19 12h1.5a1 1 0 0 1 0 2H19" />
    </svg>
  );
}

export default ApiHelpLinks;
